
<template>
  <div class="contact">

                   <section id="banner">
                  <div class="content">
                    <header>
                      <h1>Contact Us</h1>
                    </header>
                    <p>
                      Contact us for more information on anything, to purchase one of our add on units or just to ask us a question. We will get back to you within 24 hours. <br/>
                      If you select the Support category, a support ticket will be created in addition.
                   </p>
                  </div>
      
                </section>

                <section class="empty">&nbsp;</section>
    <div class="row uniform">
                              <div class="6u 12u$(xsmall)">
                                <input name="demo-name" id="demo-name" value="" placeholder="Name" type="text">
                              </div>
                              <div class="6u$ 12u$(xsmall)">
                                <input name="demo-email" id="demo-email" value="" placeholder="Email" type="email">
                              </div>
                              <!-- Break -->
                              <div class="12u$">
                                <div class="select-wrapper">
                                  <select name="demo-category" id="demo-category">
                                    <option value="">- Category -</option>
                                    <option value="info">Information</option>
                                    <option value="store">Purchase</option>
                                    <option value="support">Support</option>
                                    <option value="question">Question</option>
                                    <option value="other">Other</option>
                                  </select>
                                </div>
                              </div>
                              <!-- Break -->
                              <div class="4u 12u$(small)">
                                <input id="demo-priority-low" name="demo-priority" checked="" type="radio">
                                <label for="demo-priority-low">Low</label>
                              </div>
                              <div class="4u 12u$(small)">
                                <input id="demo-priority-normal" name="demo-priority" type="radio">
                                <label for="demo-priority-normal">Normal</label>
                              </div>
                              <div class="4u$ 12u$(small)">
                                <input id="demo-priority-high" name="demo-priority" type="radio">
                                <label for="demo-priority-high">High</label>
                              </div>
                              <!-- Break -->
                              <div class="6u 12u$(small)">
                                <input id="demo-copy" name="demo-copy" type="checkbox">
                                <label for="demo-copy">Email me a copy</label>
                              </div>
                              <div class="6u$ 12u$(small)">
                                <input id="demo-human" name="demo-human" checked="" type="checkbox">
                                <label for="demo-human">I am a human</label>
                              </div>
                              <!-- Break -->
                              <div class="12u$">
                                <textarea name="demo-message" id="demo-message" placeholder="Enter your message" rows="6"></textarea>
                              </div>
                              <!-- Break -->
                              <div class="12u$">
                                <ul class="actions">
                                  <li><input value="Send Message" class="special" type="submit"></li>
                                  <li><input value="Reset" type="reset"></li>
                                </ul>
                              </div>
                            </div>
  </div>
</template>

<script>
export default {
    name: "contact",
}
</script>

<style scoped>
</style>
